import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { SkbankOmniU } from "./SkbankOmniU";
import ApiProxy from "../../ts/ApiProxy";
import schema from "@schema/common/get-coupon-help.json";
import EZAlert from "../popups/EZAlert";
import Popups from "../popups/Popups";
import schema2 from "@schema/marketing/obtain-coupon.json";

export default class MarketingCoupon extends ComponentBase
{
  constructor(elem: ComponentElem, data?: SkbankOmniU.Coupon)
  {
    super(elem);

    let isLogin = ApiProxy.getCommonPageData().login_state.is_login;

    if(data)
    {      
      this.$root.find(`.title`).text(data.title);
      this.$root.find(`.name`).text(data.name);
      let $help = this.$root.find(".help");

      if(isLogin)
      {
        this.$root.attr("is-obtained", data.is_obtained? "true": "false");
        this.$root.find(".btn-obtain").on("click", (event:JQuery.ClickEvent)=>
        {
          event.preventDefault();

          ApiProxy.quickCall("marketing/obtain-coupon", {coupon_marketing_id: data.coupon_marketing_id}, undefined, {schema: schema2, exampleIndex: 0}).then(()=>
          {
            this._obtained();
          })
        });
      }
      else
      {
        this.$root.attr("is-obtained", "false");
        this.$root.find(".btn-obtain").on("click", (event:JQuery.ClickEvent)=>
        {
          event.preventDefault();
          Popups.to("login");
        });
      }

      if(data.is_help_exist)
      {
        $help.on("click", (event:JQuery.ClickEvent)=>
        {
          event.preventDefault();
          
          ApiProxy.quickCall("common/get-coupon-help", {"coupon_class_id": data.coupon_class_id}, undefined, {schema: schema, exampleIndex: 0}).then((result)=>
          {
            EZAlert.instance.alert("關於折扣券", result.data, false, undefined, undefined, {theme: "eula", closeByCover: true, closeByX: true});
          });
        });
      }
      else
      {
        $help.detach();
      }
    }
    
  }

  private _obtained()
  {
    this.$root.find(".btn-obtain").off("click");
    this.$root.attr("is-obtained", "true");
  }
}